export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0014s_0000_Black-&-White-41.cfe40e8d.png";